<template>
    <div class="w-100 p-1 d-flex justify-content-center align-items-center bg-primary">
        <span class="font-weight-bold text-white"
            >Upgrade your account today and get a special introductory price.
        </span>
        &nbsp;
        <a class="text-white" style="text-decoration: underline;" href="/upgrade">Find out more.</a>
    </div>
</template>

<script>
export default {
    name: "UpgradeWidget",
};
</script>
